import { useTranslation } from 'react-i18next'

/** Lets a keyboard user jump past the header straight to the form. SC 2.4.1. */
export function SkipLink() {
  const { t } = useTranslation('common')

  return (
    <a
      href="#main"
      className="sr-only-focusable absolute top-2 left-2 z-50 rounded bg-panel px-2 py-1 text-label text-white"
    >
      {t('a11y.skipToContent')}
    </a>
  )
}
